import { Component, ViewEncapsulation } from '@angular/core';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./scss/app.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {

    constructor(
        protected googleAnalytics: GoogleAnalyticsService
    ) {}

}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/app.component.ts